import React from "react";
import { Card, SectionTitle, StatusPill } from "../ui-bj/Primitives";
import { num, str, fmtDate } from "../../lib/airtableHelpers";
import { X } from "@phosphor-icons/react";

export const ClientDetailPanel = ({ client, serviceSummaries, onClose }) => (
  <Card data-testid="client-detail-panel" className="xl:sticky xl:top-6 self-start">
    <div className="flex items-start justify-between mb-4">
      <div>
        <div className="bj-label">Client Detail</div>
        <div className="font-heading text-[#2A1C15] text-2xl tracking-wide">{str(client.fields?.["Full Name"])}</div>
        <div className="text-[#6E5022] bj-tnum text-xs">
          ID {str(client.fields?.["Client ID"])} · {str(client.fields?.["Service Package"], "no package")}
        </div>
      </div>
      <button data-testid="close-detail-panel" onClick={onClose} className="text-[#5E4D40] hover:text-[#5C1A24]" aria-label="close">
        <X size={20} />
      </button>
    </div>

    <div className="grid grid-cols-2 gap-3 mb-5 text-sm">
      <div><div className="bj-label">Status</div>{client.fields?.["Client Status"] ? <StatusPill status={client.fields["Client Status"]} /> : <span className="text-[#5E4D40]">—</span>}</div>
      <div><div className="bj-label">Payment</div>{client.fields?.["Payment Status"] ? <StatusPill status={client.fields["Payment Status"]} /> : <span className="text-[#5E4D40]">—</span>}</div>
      <div><div className="bj-label">Email</div><div className="text-[#2A1C15] text-xs break-all">{str(client.fields?.["Email"])}</div></div>
      <div><div className="bj-label">Phone</div><div className="text-[#2A1C15] text-xs">{str(client.fields?.["Phone"])}</div></div>
      <div><div className="bj-label">Joined</div><div className="text-[#2A1C15] bj-tnum">{fmtDate(client.fields?.["Date Joined"])}</div></div>
      <div><div className="bj-label">Days</div><div className="text-[#6E5022] font-heading text-lg bj-tnum">{num(client.fields?.["Days as Client"]) ?? "—"}</div></div>
      <div><div className="bj-label">Next Appt</div><div className="text-[#2A1C15] bj-tnum">{fmtDate(client.fields?.["Next Appointment"])}</div></div>
      <div><div className="bj-label">Consultant</div><div className="text-[#2A1C15]">{str(client.fields?.["Consultant Assigned"])}</div></div>
    </div>

    <SectionTitle>Service Records</SectionTitle>
    <ul className="flex flex-col gap-2">
      {serviceSummaries.map((s) => (
        <li key={s.label} className="flex items-center justify-between border border-[rgba(42,28,21,0.18)] px-3 py-2.5">
          <div>
            <div className="font-heading text-[#2A1C15] tracking-wide text-sm">{s.label}</div>
            <div className="text-[#5E4D40] text-xs">{s.count} record{s.count === 1 ? "" : "s"} · {s.detail}</div>
          </div>
          <StatusPill status={s.status} />
        </li>
      ))}
    </ul>

    {client.fields?.Notes && (
      <div className="mt-4 pt-4 border-t border-[rgba(42,28,21,0.18)]">
        <div className="bj-label mb-1">Notes</div>
        <div className="text-[#2A1C15] text-xs whitespace-pre-wrap">{client.fields.Notes}</div>
      </div>
    )}
  </Card>
);
